import React from "react";

import DeleteToolbarButton from "./DeleteToolbarButton";
import CheckboxButton from "core/CheckboxButton";

import { SelectedControlsContainer, ToolbarButton } from "./styles";

const SelectAllToolbarButton = ({ isSelectAllChecked, handleChange }) => {
    return (
        <CheckboxButton
            size="xs"
            label="Select All"
            inputValue="select-all"
            ariaId="select-all-photos"
            isChecked={isSelectAllChecked}
            onChange={handleChange}
        />
    );
};

const EditToolbarButton = ({ quantityChecked, handleClick }) => {
    if (quantityChecked < 1) return null;

    const getButtonText = () => {
        if (quantityChecked === 1) {
            return "Edit 1 photo";
        } else if (quantityChecked > 1) {
            return `Edit ${quantityChecked} photos`;
        }
    };

    return (
        <ToolbarButton onClick={handleClick}>{getButtonText()}</ToolbarButton>
    );
};

const PhotoUploadToolbarSelectedControls = ({
    openEditModal,
    isSelectAllChecked,
    quantityChecked,
    handleSelectAllChange
}) => {
    return (
        <>
            <SelectAllToolbarButton
                isSelectAllChecked={isSelectAllChecked}
                handleChange={handleSelectAllChange}
                quantityChecked={quantityChecked}
            />
            <EditToolbarButton
                handleClick={openEditModal}
                quantityChecked={quantityChecked}
            />
            <DeleteToolbarButton quantityChecked={quantityChecked} />
        </>
    );
};

export default PhotoUploadToolbarSelectedControls;
